module.exports = __webpack_public_path__ + "media/images/iconInfo__inFrontOfAccent-bc286d51df1d2f3d9d39768301c8155a.png";